import type { ReactNode } from 'react';
import { useProBranding } from '@/lib/pro-branding';

export function AuthLayout({ children }: { children: ReactNode }) {
  const { loginLogoUrl } = useProBranding();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-12"
      style={{ background: 'var(--pro-bg)' }}
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          {loginLogoUrl ? (
            <img
              src={loginLogoUrl}
              alt="Pro"
              className="mx-auto max-h-16 max-w-[220px] object-contain"
            />
          ) : (
            <div className="flex items-baseline justify-center gap-1.5">
              <span
                className="text-[28px] font-bold leading-none"
                style={{ fontFamily: 'Figtree', color: 'var(--pro-text-dark)' }}
              >
                Tunelec
              </span>
              <span
                className="text-[28px] font-semibold italic leading-none"
                style={{ fontFamily: 'Figtree', color: 'var(--pro-primary)' }}
              >
                Pro
              </span>
            </div>
          )}
          <p
            className="text-[14px] mt-2"
            style={{ color: 'var(--pro-text-grey)', fontFamily: 'Figtree' }}
          >
            Espace professionnel
          </p>
        </div>
        <div
          className="bg-white rounded-2xl p-6 sm:p-8"
          style={{
            boxShadow: '0 1px 2px rgba(13, 13, 18, 0.06)',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
